module.exports = __webpack_public_path__ + "Roboto-Light.46e48ce0628835f68a73.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Light.ttf
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Light.ttf
// module chunks = styles